import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';

import { useCheckKakaobank } from './useCheckKakaobank';

//* 자체 크롬 없이 제휴사 셸 안에서만 도는 호스트 — 여기선 www로 보내는 순간 탈출구가 사라진다
export const useCheckPartnerWebview = () => {
  const isKakaobank = useCheckKakaobank();
  //* 셸 판정과 달리 탈출구는 www로 열린 카뱅 웹뷰에도 필요해 UA를 보강한다
  const isKakaobankWebview = useDeviceInfoStore(
    (state) => state.webviewType === WEBVIEW_TYPE.KAKAOBANK,
  );
  const isToss = useDeviceInfoStore(
    (state) => state.subDomain === SUB_DOMAIN.TOSS,
  );

  return isKakaobank || isKakaobankWebview || isToss;
};
